window.popupwindow = function (url, title, w, h) {
	var left = (screen.width / 2) - (w / 2);
	var top = (screen.height / 2) - (h / 2);
	return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
};
window.extendsFormParams = function (params, append) {
	let resultParams = params;

	for (let name in append) {
		if (typeof append[name] !== 'undefined' && typeof append[name]['name'] !== 'undefined') {
			resultParams.push(append[name]);
		} else {
			resultParams.push({name: name, value: append[name]});
		}
	}

	return resultParams;
};